"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*!
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var offline_link_1 = require("./offline-link");
exports.OfflineLink = offline_link_1.OfflineLink;
exports.replaceUsingMap = offline_link_1.replaceUsingMap;
var complex_object_link_1 = require("./complex-object-link");
exports.ComplexObjectLink = complex_object_link_1.ComplexObjectLink;
